module.exports = __webpack_public_path__ + "img/transparent_gitlab.c0cf1d6a.png";